import WebAPI from './api-calls';

const webApi = new WebAPI();

export async function fetchWasteCharges() {
    const endpoint = '/api/multiutility/waste-charges';

    const response = await webApi.getFromWebApiWithAccessTokenAsync(endpoint);

    return response.data;
}
